<template>
   <div class="sa-main" :style="{ overflow: loading?'hidden':'auto',flex: loading?'0 0 0':'1'}">
      <div class="nuxt-loading-indicator" style="position:fixed;top:0;right:0;left:0;pointer-events:none;width:0%;height:5px;opacity:0;background:repeating-linear-gradient(to right,#00dc82 0%,#34cdfe 50%,#0047e1 100%);transition:width 0.1s, height 0.4s, opacity 0.4s;z-index:999999;"></div>
      
      <div data-v-27c50073>
         
         <div class="el-row main-banner panel-block" style="" data-v-27c50073>
            <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-4 el-col-lg-3 el-col-xl-3" style="" data-v-27c50073> </div>
            <div id="content" class="el-col el-col-24 el-col-xs-24 el-col-sm-20 el-col-md-16 el-col-lg-18 el-col-xl-18" style="" data-v-27c50073>
               <div class="content" data-v-27c50073>
                  <div class="scrollbar" data-v-27c50073>
                     <div class="el-scrollbar" data-v-27c50073>
                        <div class="el-scrollbar__wrap el-scrollbar__wrap--hidden-default" style="">
                           <div class="el-scrollbar__view" style="">
                              <div class="list" data-v-27c50073>
                                 <div class="sa-button list-btn " @click="scrollto(index)" :class="[status == index && 'is-active']" data-v-27c50073
                                 v-for="(item, index) in functionList" :key="index">{{item.title}}</div>
                              </div>
                           </div>
                        </div>
                         <div class="el-scrollbar__bar is-horizontal" style="display:none;">
                           <div class="el-scrollbar__thumb" style="width:0;transform:translateX(0%);"></div>
                        </div>
                        <div class="el-scrollbar__bar is-vertical" style="display:none;">
                           <div class="el-scrollbar__thumb" style="height:0;transform:translateY(0%);"></div>
                        </div>
                     </div>
                  </div>
                  <img class="title-bg" src="@/assets/image/gnjs/function.png" data-v-27c50073>
                  <div class="title" data-v-27c50073>火烈鸟游戏约玩拥有强大的游戏陪玩、即时通讯、语聊陪伴、商城购物、圈子话题、活动中心、会员服务、道具商城、礼物特效、个人主页、任务中心、全端分享等功能。 </div>
                  <img class="title-img" src="@/assets/image/gnjs/function-matchimage.png" data-v-27c50073>
               </div>
            </div>
            <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-4 el-col-lg-3 el-col-xl-3" style="" data-v-27c50073></div>
            <div class="content-container" data-v-27c50073
               v-for="(item,index) in functionList" :key="index">
               <div class="el-row" :class="[index%2==0 && 'grey-bg']" style="" data-v-27c50073>
                  <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-4 el-col-lg-3 el-col-xl-3" style="" data-v-27c50073></div>
                  <div class="el-col el-col-24 el-col-xs-24 el-col-sm-20 el-col-md-16 el-col-lg-18 el-col-xl-18" style="" data-v-27c50073>
                     <div data-v-27c50073>
                        <div class="container-box" :id="'container'+index" :class="[index%2==0 && 'reverse-box']" data-v-27c50073>
                           <img class="container-box-left" :src="item.image" data-v-27c50073>
                           <div class="container-box-right" data-v-27c50073>
                              <div class="right-title" data-v-27c50073>{{item.title}}</div>
                              <div data-v-27c50073 v-for="(ele,value) in item.data" :key="value">
                                 <div class="right-item-title" data-v-27c50073>{{bigNumber[value]}}. {{ele.name}}</div>
                                 <div class="right-item-desc" data-v-27c50073>{{ele.text}}</div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-4 el-col-lg-3 el-col-xl-3" style="" data-v-27c50073></div>
               </div>
            </div>
         </div>

      </div>
      <div class="loading" v-if="loading">
         <div class="spinner"></div>
      </div>
   </div>
</template>
<script>
   export default {
      name: 'function',
      data(){
         return {
            loading: true,
            bigNumber:['一','二','三','四','五','陆','柒'],
            functionList:[
               {
                  title:'全平台覆盖',
                  image:require('@/assets/image/gnjs/0.png'),
                  data:[
                     {
                        name:'H5、APP、小程序',
                        text:'多渠道部署，满足多样化需求'
                     },{
                        name:'全方位引流',
                        text:'聚合流量曝光引流'
                     },{
                        name:'免费更新',
                        text:'长期支持免费更新'
                     }
                  ]
               },{
                  title:'游戏陪玩',
                  image:require('@/assets/image/gnjs/1.png'),
                  data:[
                     {
                        name:'大神评价',
                        text:'完善的大神评价体系、系统根据服务技能评估自身评分。'
                     },{
                        name:'快速约玩',
                        text:'系统根据用户特定喜好快速适配适合自己的大神约玩。'
                     },{
                        name:'信息明晰',
                        text:'用户可查看大神技能水平，接单数量、服务态度、相应速度等功能'
                     }
                  ]
               },{
                  title:'即时通讯',
                  image:require('@/assets/image/gnjs/2.png'),
                  data:[
                     {
                        name:'消息必达',
                        text:'可一对一发送文字/图片/语音/视频等消息'
                     },{
                        name:'实时语音',
                        text:'可一对一拨打语音电话即时沟通'
                     },{
                        name:'系统速配',
                        text:'一对一沟通清晰展示对方兴趣爱好，匹配度方便更好的服务'
                     }
                  ]
               },{
                  title:'语聊陪伴',
                  image:require('@/assets/image/gnjs/3.png'),
                  data:[
                     {
                        name:'语聊派对',
                        text:'用户可快速创建语聊派对房间'
                     },{
                        name:'房间守护',
                        text:'用户可守护房主，提升房间评分'
                     }
                  ]
               },{
                  title:'商城购物',
                  image:require('@/assets/image/gnjs/4.png'),
                  data:[
                     {
                        name:'实物商品',
                        text:'购买商品系统快递发货'
                     },{
                        name:'虚拟商品',
                        text:'点卡/游戏卡等虚拟商品的销售'
                     }
                  ]
               },{
                  title:'圈子话题',
                  image:require('@/assets/image/gnjs/5.png'),
                  data:[
                     {
                        name:'热门话题',
                        text:'系统根据用户发布的内容区分当前热门话题'
                     },{
                        name:'多类型帖子',
                        text:'可发布文字/图片/语音/视频/付费/链接/网盘/投票/红包等帖子'
                     }
                  ]
               },{
                  title:'活动中心',
                  image:require('@/assets/image/gnjs/6.png'),
                  data:[
                     {
                        name:'热门活动',
                        text:'系统根据活动热度展示用户举办的线下活动'
                     },{
                        name:'发布活动',
                        text:'会员可发起各种类型活动'
                     }
                  ]
               },{
                  title:'会员服务',
                  image:require('@/assets/image/gnjs/7.png'),
                  data:[
                     {
                        name:'会员级别',
                        text:'会员根据级别的不同享受不同的权益'
                     },{
                        name:'会员权益',
                        text:'专属徽章/状态隐身/每日抽奖/动态置顶/专属礼物/积分经验'
                     },{
                        name:'会员抽奖',
                        text:'可每日参与抽奖获取积分'
                     }
                  ]
               },{
                  title:'道具商城',
                  image:require('@/assets/image/gnjs/8.png'),
                  data:[
                     {
                        name:'道具卡',
                        text:'置顶卡/交由卡/呼唤卡'
                     },{
                        name:'挂饰头像',
                        text:'各种类型挂饰和头像框'
                     },{
                        name:'聊天气泡',
                        text:'各种聊天气泡的展示'
                     }
                  ]
               },{
                  title:'礼物特效',
                  image:require('@/assets/image/gnjs/9.png'),
                  data:[
                     {
                        name:'一对一礼物',
                        text:'支持多端消息发送(礼物、宠物、头像框、聊天气泡)'
                     },{
                        name:'语聊房特效',
                        text:'特效礼物满屏展示'
                     }
                  ]
               },{
                  title:'个人主页',
                  image:require('@/assets/image/gnjs/10.png'),
                  data:[
                     {
                        name:'资料信息',
                        text:'展示个人简介、我的守护、收到的礼物等信息'
                     },{
                        name:'服务技能',
                        text:'展示自己发布的服务技能'
                     },{
                        name:'综合评价',
                        text:'展示所有技能的综合评分。'
                     }
                  ]
               },{
                  title:'任务中心',
                  image:require('@/assets/image/gnjs/11.png'),
                  data:[
                     {
                        name:'签到',
                        text:'根据签到获得相应积分'
                     },{
                        name:'做任务赚金币',
                        text:'做系统发布的任务获得金币'
                     }
                  ]
               }
            ],

            topdata:[],
            status:0
         }
      },
      methods:{
         getElementToPageTop(el) {
            if(el.parentElement) {
               return this.getElementToPageTop(el.parentElement) + el.offsetTop
            }
            return el.offsetTop
         },
         scrollto(index){
            window.scrollTo({top: this.topdata[index], behavior:'smooth'});
         }
      },
      components: {
        
      },
      mounted(){
         window.scrollTo({top: 0, behavior:'smooth'});
         let that = this;
         setTimeout(() => {
            this.loading = false;
         },500)
         setTimeout(() => {
            that.containers = Array.from(document.querySelectorAll('.content-container'));
            that.containers.forEach((ele,index)=>{
               that.topdata.push(that.getElementToPageTop(ele))
            })
            document.addEventListener("scroll", function(e){
               var t =document.documentElement.scrollTop||document.body.scrollTop;
               if(that.topdata.length>0){
                  that.topdata.forEach((item,index)=>{
                     if(index<that.topdata.length - 2){
                        if(t>=item - 60 - (that.containers[index].offsetHeight/2)&&t<that.topdata[index+1]){
                           that.status = index;
                        }
                     }else{
                        if(t>=item - 60 - (that.containers[index].offsetHeight/2)){
                           that.status = index;
                        }
                     }
                  })
               }
            });
         },300)
      },
      beforeDestroy() {
         document.removeEventListener("scroll", () => {
            
         })
      },
   };
</script>
<style scoped>
   
   
   @import '../assets/css/index.css';
   @import '../assets/css/function.css';
  .loading {
     
     position: fixed;
     top: 0;
     left: 0;
     width: 100vw;
     height: 100vh;
     display: flex;
     z-index: 99999;
     background-color: rgba(255, 255, 255, .8);
     justify-content: center;
     align-items: center;
  }
  
  .loading .spinner {
     width: 50px;
     height: 50px;
     border: 5px solid #c0b5ff;
     border-top-color: #986bff;
     border-radius: 50%;
     animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
     0% {
        transform: rotate(0deg);
     }
     100% {
        transform: rotate(360deg);
     }
  }
</style>